import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { format, parse, differenceInCalendarDays } from "date-fns";
import EnergyBreakdown from "@solarschools/component-lib/components/EnergyBreakdown";
import GraphDateControls from "@solarschools/component-lib/components/GraphDateControls";
import LoadingDots from "../../../LoadingDots/LoadingDots";
import GraphSwitch from "../GraphSwitch";
import NoDataAvailable from "../../../NoDataAvailable";
import { EnergyBreakdownTooltip } from "../../tooltips/EnergyBreakdownTooltip";
// import { autoFormatEnergyValue } from "@solarschools/component-lib/src/utilities/EnergyUnits";
// import { autoFormatMassValue } from "../util/MassUnits";
// import { PlainTextConversionStream } from "parse5";

require("amcharts");
require("amcharts.serial");
require("amcharts.themes.light");
require("amcharts.react");
require("amcharts.pie");
require("amcharts.responsive");

export const Summary = ({
  isLive,
  start,
  end,
  mode,
  solarConsumption,
  solarReturned,
  solarGenerated,
  gridConsumption,
  co2Produced,
  co2Saved,
  systemCapacity,
  selectionCallback,
  fetching,
  setIsKW,
}) => {
  const sameDay = (d1, d2) => {
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  };

  // day diff
  const dayDiff = differenceInCalendarDays(
    end || new Date(),
    start || new Date()
  );

  return (
    <Fragment>
      {" "}
      <div className="row w-100 mx-0 pb-1">
        <h2 className="ss-title text-left">
          <span className="text-ss-dark">
            <strong>Grid vs.</strong>{" "}
          </span>
          <span className="text-pw-green">
            <strong>Green</strong>
          </span>
        </h2>
        <br />
      </div>
      <div className="row d-flex flex-row mx-0">
        <div className="col-12 col-lg-6 pb-4 pb-sm-5 pb-lg-0 pl-0 pr-4">
          <div className="w-50 d-flex justify-content-start pb-3 pt-1 align-items-center">
            <GraphDateControls
              selectionCallback={selectionCallback}
              mode={mode}
              startDate={start}
              endDate={end}
            />
          </div>{" "}
          {dayDiff <= 1 && !isLive && (
            <div>
              <GraphSwitch
                callback={(val) => setTimeout(() => setIsKW(val), 300)}
              />
              <br />
            </div>
          )}
          <div className="row mx-0 text-left text-ss-dark">
            <h4 className="h5 h5-sm pb-2">
              Showing data for{" "}
              <span>
                <strong>
                  {mode !== "LIFETIME"
                    ? !sameDay(start, end)
                      ? format(start, "iii MMM dd, yyyy") +
                        " to " +
                        format(end, "iii MMM dd, yyyy")
                      : format(start, "iii MMM dd, yyyy")
                    : "Lifetime"}
                </strong>
              </span>
            </h4>
          </div>
          <p className="text-left text-ss-dark">
            Every school will have different results depending on their energy
            usage, positioning of their solar panels and lots of other factors.
          </p>
          {/* <p className="text-left text-ss-dark">
            Check out your school's performance below or visit the{" "}
            <span>
              <a href="/compare">
                <u>compare page</u>
              </a>
            </span>{" "}
            to see how your school's systems perform against others.
          </p> */}
        </div>
        <div className="col-12 col-lg-6 pr-4 pt-0 pb-4 flex-grow-1 align-items-center justify-content-center">
          {fetching ? (
            <div className="aspect-ratio aspect-ratio-30by10">
              <div className="aspect-ratio-content text-center d-flex flex-column justify-content-center align-items-center">
                <LoadingDots spinnerClass="bg-primary" />
              </div>
            </div>
          ) : !gridConsumption && !solarReturned && !solarConsumption ? (
            <NoDataAvailable />
          ) : (
            // todo fix the breakdownbar variable mapping because its backwards for some reason
            <Fragment>
              <div className="w-100 d-flex justify-content-end">
                <EnergyBreakdownTooltip />
              </div>
              <EnergyBreakdown
                title={"Energy breakdown "}
                energy={{
                  energyExported: gridConsumption,
                  energyImported: solarReturned,
                  energyGenerated: solarConsumption,
                }}
                consumption={gridConsumption}
                exported={solarReturned}
                generated={solarConsumption}
                date={
                  mode !== "LIFETIME"
                    ? !sameDay(start, end)
                      ? format(start, "iii MMM dd, yyyy") +
                        " to " +
                        format(end, "iii MMM dd, yyyy")
                      : format(start, "iii MMM dd, yyyy")
                    : "Lifetime"
                }
              />
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
};

Summary.propTypes = {
  start: PropTypes.instanceOf(Date),
  end: PropTypes.instanceOf(Date),
  solarConsumption: PropTypes.number,
  solarReturned: PropTypes.number,
  solarGenerated: PropTypes.number,
  gridConsumption: PropTypes.number,
  co2Produced: PropTypes.number,
  co2Saved: PropTypes.number,
  systemCapacity: PropTypes.number,
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/Summary/Summary.js